import { render, staticRenderFns } from "./recognitionSingle.vue?vue&type=template&id=4008897c&scoped=true"
import script from "./recognitionSingle.vue?vue&type=script&lang=js"
export * from "./recognitionSingle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4008897c",
  null
  
)

export default component.exports